import { type ISchema } from 'yup';
import { yup } from './initYup.ts';

/**
 * Riconosce se uno schema è di tipo boolean
 */
export function isYupBooleanSchema(schema: ISchema<any>) {
  return schema instanceof yup.Schema && schema.type === 'boolean';
}
